module.exports = __webpack_public_path__ + "img/Dennis_Headshot-photoaidcom-cropped.7532540b.JPG";